import { render, staticRenderFns } from "./AccettazioneSsnListaPage.vue?vue&type=template&id=12ba17fc&scoped=true"
import script from "./AccettazioneSsnListaPage.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnListaPage.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnListaPage.vue?vue&type=style&index=0&id=12ba17fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba17fc",
  null
  
)

export default component.exports